import { apiClient } from "lib/apiClient";

export const deleteUser = async <T>(id: string): Promise<T> => {
  const response = await apiClient.delete(`/users/${id}`);

  return response.data;
};
